/**
 * The DOM id a committed chapter publishes, in one place because two features link to it: the
 * journal jumps here and the feed's scroll anchoring measures around it.
 *
 * Its own module rather than an export from `ChapterScene` so that Fast Refresh keeps working
 * on the component — a file that exports both a component and a helper cannot be hot-replaced.
 */
export function chapterElementId(number: number): string {
  return `chapter-${String(number)}`;
}
